import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import BB from '../images/BB.png';
import Tile from '../images/Tile.png';
import Header from '../Component/Header';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Footer from '../Component/Footer';
import ProjectHeader from '../Component/ProjectHeader';
import WindowListPopup from '../Component/WindowCountPopup';

function WindowsStandardQuoteDetails() {
  const navigate = useNavigate();
     const location = useLocation();
     const quotationId = location?.state?.quotationId
     const type = location?.state?.type
     const [showWindowListPopup, setShowWindowListPopup] = useState(false);
  const [selectedWindowItem, setSelectedWindowItem] = useState(null);
  const [showWindowVendorPopup, setShowWindowVendorPopup] = useState(false);
const [selectedVendor, setSelectedVendor] = useState(null);

     console.log(type)
     //console.log(quotationId)
//const quotationId = '67f4b6c7a74b6948095cd1c3'
const [data , setData] = useState({});
console.log(data)
  useEffect(() => {
      fetchQuotationDetails();
  }, [quotationId]);

    const fetchQuotationDetails = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-quote?quotation_id=${quotationId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
               
        const data = await response.json();
        //console.log(data)
        console.log(data.data.quotation);
        setData(data.data.quotation);
        //console.log(sampleData)
      } catch (err) {
        console.error('Error fetching quotation details:', err);
      }
    };
    
    const sampleData = {
        _ic: "IC12345",
        quotation_number: "QT-2024-0001",
        project_name: "Project A",
        quotation_date: "2024-03-15",
        expiry_date: "2024-04-15",
        status: "Pending",
        package_id: "PKG-TILES-STD-001",
        package_name: "Standard Tiles Package",
        Total_Price : "12,50,300",
        vendors: [ // Vendors object with id, name, image
           { 
            id: "VEN001",
            name: "Krafto", 
            image: "data:image/png;base64,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",
            product_subcategory_data: [
              { name: "600x1200mm", id: "CT001", price: [30] }, // Example prices
              { name: "800x1600mm", id: "PT001", price: [40] }
            ]
          }, {
            id: "VEN002",
            name: "Pollens",
            image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAk1BMVEUAAAD///8TExMXFxcQEBC9azGgoKD09PSjo6M9PT36+vqysrKCgoKpqamYmJh5eXlSUlJDQ0Pu7u7FxcXe3t4hISFpaWm5ubkuLi5+fn5eXl7o6OglJSXw8PD5iDSIiIg1NTVLS0vV1dVxcXHMcjKQkJBYMhZgYGDMzMyqYCojDgAqDwD/kj5JKhQcHR2ATimXWi9t6SdKAAAEuklEQVR4nO3Zh5KqSACF4WZgkWBjFkRnMdxZ3eS97/902w2GoWmZWVPVsc5fNQmU5kMkjGLvvXZ78SZeuzcK4aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQvxcSZp518ssIw2Lb7dtmvIxwtsmnhW3Gywh73fyjZ9tPX0cYismHbUar0MvKlrqwbHGaF9artt4iyy4taH9hjGW/WVYuKTMOHW6WudUooZlerU2vZx2gVTjo6KJjjuN0RtWazub6r3PRMNCT0yia2BY0jaLEPkRSX06VL8Q6UiMPd583WDeKZurHftRpPOHCwr8htIw+1zMKy4xUTR85jl14aSWmlgWVjx1/Gu2QGrSrdoe5/QlXC6NOLbXF1Yu1UD/q0/Vmza8Q+uUOEH0a5X04nxelsFxoYAplY53UWlnfgN8UpvUpeaQ368ZxRsZDE8eRVwj1+uau2zwGjp1IjaaIg9OkSqjoq8trbOkroSl510I1lvmuXpUb4xrh3DpDQdT32HHWp0mVcO4ML6+wrXsJ+w8RquG0quo1her90DmeoZ4jXEbPFYrd+VBwFNqfcLGvhX/+KPtrMF6v1+rwFj9A6EfvVZ1hWM04CrPqIK07CqOh2bu5p/0/4Y/fdf/83a9OPZ3JA4TyfOlgCMWHc9wtK+HQegYdWJd+lXC8FM8V6t+CT8I0anaj8N8/ysR+m+f56jjWfYXZ4JRnCvWWDc9C84I4DLPdjUJLTzzSiPNJsfh05qg1Qhd6h5Pik4UbY9LpmsZ6l3STUPTU8c19rnDmOOa17rY8jaixlrYn5I0L3EPfEop1uR7dS8K1E1lHrbpKqO+qZFBLHcSL8vp77gdG6opc6Lsrc4acChGoGbvYKJ0aQn1SHMtdKQxjabRzWi9zrhLq16qRHkW/ZZqJStJIlmc7++1eTah3mrJudb/RyH53f4vQ2zUGmZdH9L7thKxnpHZhZruf1ff485pQdKv7+sIu9FuA7cJFkphHlGN54tc6Ps7r+WaynNFPzOnBVE+f9hrN1Fm3SOqHJnf7kSR+X10Z+4lREbYBX+d/bRejED8K8aMQvycIJ/qW7801J3tqaO8w95E9XJjFftwTvkxSdbr2k/Jr4gvp9eQ66Htq7qWLijv1cKFUFyg9IV11ySw8qe4/gtHKlSJVd1n6D/1RQOPlvWvXC3/+1tqvw8NSkclCyHSUZqLobxQ2HFVCVwk1NDjc3P1qX+DPpwu/WZxppVx4O/VqSTlSv07jkzBWunTx9VJu6OHCVVoksZBLsY1X6h5ADoKlOAuzdOa3fXB0hx5/LHX1P+j0x7mDvdol95OF+jUT+qNP/eXlLf+AuEs8H+JHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTi9yYW7mu3+A8n9lZzQ4eVqwAAAABJRU5ErkJggg==",
            product_subcategory_data: [
              { name: "1200x1800mm", id: "MT001", price: [50] },
              { name: "600x600mm", id: "GT001", price: [10] }
            ]
          }
        ],
        items: [ // Items array with vendor data inside
          {
            item_name: "600x1200mm Glossy",
            quantity: 5360, // Sum of applied areas
            unit_price: 20,   // Example unit price
            Boxes_Needed: 236, // Example boxes needed
            total_price: 6780,
            vendor: { // Vendor data embedded within each item
                id: "VEN001",
                name: "Krafto", 
                image: "data:image/png;base64,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",
                }, // Referencing vendor ID
            attributes: [
                { attribute_id: "F001", attribute_name: "Finish", attribute_value: "Glossy", attribute_value_id: "FG001" },
                { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "12.5", attribute_value_id: "BS001" }
              ],
            applied_areas: [
              { id: 1, area_name: "living", areaInSft: 520 },
              { id: 2, area_name: "kitchen" , areaInSft: 640 },
              { id: 3, area_name: "bedroom1" ,areaInSft: 200 }
            ],
            product_subcategory: { name: "600x1200mm", id: "CT001" }
          },
          {
            item_name: "600x1200mm Matt",
            quantity: 1360, // Sum of applied areas
            unit_price: 30,   // Example unit price
            Boxes_Needed: 136, // Example boxes needed
            total_price: 4080,
            vendor: { // Vendor data embedded within each item
                id: "VEN001",
                name: "Krafto", 
                image: "data:image/png;base64,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",
                }, // Referencing vendor ID
            attributes: [
                { attribute_id: "F001", attribute_name: "Finish", attribute_value: "Matt", attribute_value_id: "FM001" },
                { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "18.5", attribute_value_id: "BS002" }
              ],
            applied_areas: [
              { id: 4, area_name: "living flooring", areaInSft: 520 },
              { id: 5, area_name: "kitchen walls" , areaInSft: 640 },
              { id: 6, area_name: "balcony1 flooring" ,areaInSft: 200 }
            ],
            product_subcategory: { name: "600x1200mm", id: "CT001", price: [30] }
          },
          {
            item_name: "1200x1800mm Glossy",
            quantity: 160, // Sum of applied areas
            unit_price: 40,   // Example unit price
            Boxes_Needed: 156, // Example boxes needed
            total_price: 9968,
            vendor: { // Vendor data embedded within each item
                id: "VEN002",
                name: "Pollens",
                image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAk1BMVEUAAAD///8TExMXFxcQEBC9azGgoKD09PSjo6M9PT36+vqysrKCgoKpqamYmJh5eXlSUlJDQ0Pu7u7FxcXe3t4hISFpaWm5ubkuLi5+fn5eXl7o6OglJSXw8PD5iDSIiIg1NTVLS0vV1dVxcXHMcjKQkJBYMhZgYGDMzMyqYCojDgAqDwD/kj5JKhQcHR2ATimXWi9t6SdKAAAEuklEQVR4nO3Zh5KqSACF4WZgkWBjFkRnMdxZ3eS97/902w2GoWmZWVPVsc5fNQmU5kMkjGLvvXZ78SZeuzcK4aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQvxcSZp518ssIw2Lb7dtmvIxwtsmnhW3Gywh73fyjZ9tPX0cYismHbUar0MvKlrqwbHGaF9artt4iyy4taH9hjGW/WVYuKTMOHW6WudUooZlerU2vZx2gVTjo6KJjjuN0RtWazub6r3PRMNCT0yia2BY0jaLEPkRSX06VL8Q6UiMPd583WDeKZurHftRpPOHCwr8htIw+1zMKy4xUTR85jl14aSWmlgWVjx1/Gu2QGrSrdoe5/QlXC6NOLbXF1Yu1UD/q0/Vmza8Q+uUOEH0a5X04nxelsFxoYAplY53UWlnfgN8UpvUpeaQ368ZxRsZDE8eRVwj1+uau2zwGjp1IjaaIg9OkSqjoq8trbOkroSl510I1lvmuXpUb4xrh3DpDQdT32HHWp0mVcO4ML6+wrXsJ+w8RquG0quo1her90DmeoZ4jXEbPFYrd+VBwFNqfcLGvhX/+KPtrMF6v1+rwFj9A6EfvVZ1hWM04CrPqIK07CqOh2bu5p/0/4Y/fdf/83a9OPZ3JA4TyfOlgCMWHc9wtK+HQegYdWJd+lXC8FM8V6t+CT8I0anaj8N8/ysR+m+f56jjWfYXZ4JRnCvWWDc9C84I4DLPdjUJLTzzSiPNJsfh05qg1Qhd6h5Pik4UbY9LpmsZ6l3STUPTU8c19rnDmOOa17rY8jaixlrYn5I0L3EPfEop1uR7dS8K1E1lHrbpKqO+qZFBLHcSL8vp77gdG6opc6Lsrc4acChGoGbvYKJ0aQn1SHMtdKQxjabRzWi9zrhLq16qRHkW/ZZqJStJIlmc7++1eTah3mrJudb/RyH53f4vQ2zUGmZdH9L7thKxnpHZhZruf1ff485pQdKv7+sIu9FuA7cJFkphHlGN54tc6Ps7r+WaynNFPzOnBVE+f9hrN1Fm3SOqHJnf7kSR+X10Z+4lREbYBX+d/bRejED8K8aMQvycIJ/qW7801J3tqaO8w95E9XJjFftwTvkxSdbr2k/Jr4gvp9eQ66Htq7qWLijv1cKFUFyg9IV11ySw8qe4/gtHKlSJVd1n6D/1RQOPlvWvXC3/+1tqvw8NSkclCyHSUZqLobxQ2HFVCVwk1NDjc3P1qX+DPpwu/WZxppVx4O/VqSTlSv07jkzBWunTx9VJu6OHCVVoksZBLsY1X6h5ADoKlOAuzdOa3fXB0hx5/LHX1P+j0x7mDvdol95OF+jUT+qNP/eXlLf+AuEs8H+JHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTi9yYW7mu3+A8n9lZzQ4eVqwAAAABJRU5ErkJggg==",
                 }, // Referencing vendor ID
            attributes: [
                { attribute_id: "F001", attribute_name: "Finish", attribute_value: "Glossy", attribute_value_id: "FG002" },
                { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "12.5", attribute_value_id: "BS001" }
              ],
            applied_areas: [
              { id: 7, area_name: "Bathroom1 Flooring", areaInSft: 520 },
              { id: 8, area_name: "Bathroom2 Flooring" , areaInSft: 640 },
              { id: 9, area_name: "Bathroom3 Flooring" ,areaInSft: 200 }
            ],
            product_subcategory: { name: "1200x1800mm", id: "CT001" }
          },
          {
            item_name: "1200x1800mm Matt",
            quantity: 1760, // Sum of applied areas
      unit_price: 70,   // Example unit price
      Boxes_Needed: 116, // Example boxes needed
      total_price: 1080,
            vendor: { // Vendor data embedded within each item
                id: "VEN002",
                name: "Pollens",
                image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAk1BMVEUAAAD///8TExMXFxcQEBC9azGgoKD09PSjo6M9PT36+vqysrKCgoKpqamYmJh5eXlSUlJDQ0Pu7u7FxcXe3t4hISFpaWm5ubkuLi5+fn5eXl7o6OglJSXw8PD5iDSIiIg1NTVLS0vV1dVxcXHMcjKQkJBYMhZgYGDMzMyqYCojDgAqDwD/kj5JKhQcHR2ATimXWi9t6SdKAAAEuklEQVR4nO3Zh5KqSACF4WZgkWBjFkRnMdxZ3eS97/902w2GoWmZWVPVsc5fNQmU5kMkjGLvvXZ78SZeuzcK4aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQPwrxoxA/CvGjED8K8aMQvxcSZp518ssIw2Lb7dtmvIxwtsmnhW3Gywh73fyjZ9tPX0cYismHbUar0MvKlrqwbHGaF9artt4iyy4taH9hjGW/WVYuKTMOHW6WudUooZlerU2vZx2gVTjo6KJjjuN0RtWazub6r3PRMNCT0yia2BY0jaLEPkRSX06VL8Q6UiMPd583WDeKZurHftRpPOHCwr8htIw+1zMKy4xUTR85jl14aSWmlgWVjx1/Gu2QGrSrdoe5/QlXC6NOLbXF1Yu1UD/q0/Vmza8Q+uUOEH0a5X04nxelsFxoYAplY53UWlnfgN8UpvUpeaQ368ZxRsZDE8eRVwj1+uau2zwGjp1IjaaIg9OkSqjoq8trbOkroSl510I1lvmuXpUb4xrh3DpDQdT32HHWp0mVcO4ML6+wrXsJ+w8RquG0quo1her90DmeoZ4jXEbPFYrd+VBwFNqfcLGvhX/+KPtrMF6v1+rwFj9A6EfvVZ1hWM04CrPqIK07CqOh2bu5p/0/4Y/fdf/83a9OPZ3JA4TyfOlgCMWHc9wtK+HQegYdWJd+lXC8FM8V6t+CT8I0anaj8N8/ysR+m+f56jjWfYXZ4JRnCvWWDc9C84I4DLPdjUJLTzzSiPNJsfh05qg1Qhd6h5Pik4UbY9LpmsZ6l3STUPTU8c19rnDmOOa17rY8jaixlrYn5I0L3EPfEop1uR7dS8K1E1lHrbpKqO+qZFBLHcSL8vp77gdG6opc6Lsrc4acChGoGbvYKJ0aQn1SHMtdKQxjabRzWi9zrhLq16qRHkW/ZZqJStJIlmc7++1eTah3mrJudb/RyH53f4vQ2zUGmZdH9L7thKxnpHZhZruf1ff485pQdKv7+sIu9FuA7cJFkphHlGN54tc6Ps7r+WaynNFPzOnBVE+f9hrN1Fm3SOqHJnf7kSR+X10Z+4lREbYBX+d/bRejED8K8aMQvycIJ/qW7801J3tqaO8w95E9XJjFftwTvkxSdbr2k/Jr4gvp9eQ66Htq7qWLijv1cKFUFyg9IV11ySw8qe4/gtHKlSJVd1n6D/1RQOPlvWvXC3/+1tqvw8NSkclCyHSUZqLobxQ2HFVCVwk1NDjc3P1qX+DPpwu/WZxppVx4O/VqSTlSv07jkzBWunTx9VJu6OHCVVoksZBLsY1X6h5ADoKlOAuzdOa3fXB0hx5/LHX1P+j0x7mDvdol95OF+jUT+qNP/eXlLf+AuEs8H+JHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTiRyF+FOJHIX4U4kchfhTi9yYW7mu3+A8n9lZzQ4eVqwAAAABJRU5ErkJggg==",
                 }, // Referencing vendor ID
            attributes: [
                { attribute_id: "F001", attribute_name: "Finish", attribute_value: "Matt", attribute_value_id: "FM002" },
                { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "18.5", attribute_value_id: "BS002" }
              ],
            applied_areas: [
              { id: 10, area_name: "Bathroom1 Walls", areaInSft: 520 },
              { id: 11, area_name: "Bathroom2 Walls" , areaInSft: 640 },
              { id: 12, area_name: "Bathroom3 Walls" ,areaInSft: 200 }
            ],
            product_subcategory: { name: "1200x1800mm", id: "CT001" }
          }
        ],
      };
      
      const handleCustomizeClick = () => {
        console.log("Navigating to customize with type:", type); 
        navigate('/consumer/app/windowscustomize', { 
          state: {
            data,
            type: type // Make sure to pass the type explicitly
          } 
        });
      };

      const handleWindowCountClick = (item, e) => {
        e.stopPropagation(); // Prevent any parent click handlers from firing
        setSelectedWindowItem(item);
        setShowWindowListPopup(true);
      };

     
      

return(
  <div className="bg-gray-100">
       
      <Header />
    
      <div className="sticky top-0 z-20 bg-white">
    <ProjectHeader 
  projectName={data?.project_id?.projectName}
  type={'Quote Summary'}
  categoryName={data?.product_category_id?.product_category_name}
  Name={data?.customized_by ? data.quotation_number : (data?.package_name || data?.quotation_number)}
  Title={data?.customized_by ? 'My Saved Quote' : 'Quote by Brickbucket'}
  buildcoins={
      data?.buildcoins && Array.isArray(data.buildcoins)
        ? data.buildcoins.reduce((sum, item) => sum + (item?.reserved_coins ?? 0), 0)
        : 0
    }
/>

    {data?.customized_by && (
      <div className="bg-green-50 px-4 py-3 border-b border-green-100 mb-4">
        <p className="flex items-center justify-center text-md text-gray">
          <span className="font-regular">Customized Quotation : </span>
          <span className="ml-1 font-bold text-lg">{data.quotation_number}</span>
        </p>
      </div>
    )}
  </div>


<div className='pb-32 mx-4 mt-4'>
  {console.log(data.items)}
  {data?.items?.map((item) => (
    <div key={item.vendor.id + item.item_name} className="border bg-white border-gray-300 rounded-lg overflow-hidden mb-3 shadow-md">
      <div className="p-3">
        {/* Header section with area name and measurements */}
        <div className="flex justify-between items-center mb-2">
          <h5 className="text-red-500 text-lg font-bold truncate max-w-[200px]">
            {item?.application_areas?.area_name}
          </h5>
       <div className='flex flex-col items-end'>
  <div className="flex items-center">
    {/* <p className="text-gray-500 text-xs">{item.areaInSft} sq.ft</p> */}
    {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 ml-1 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg> */}
  </div>
  <div className="flex items-center">
    <p className="text-blue-500 text-xs font-bold" 
  onClick={(e) => handleWindowCountClick(item, e)}>
  {item.application_areas?.count} Windows
</p>
  </div>
</div>

        </div>
        
        {/* Vendor and item name section */}
        <div className='flex items-center mb-3'>
        <img
  src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.vendor.image}
  alt={item.vendor.name}
  className="w-10 h-10 rounded-md mr-2 cursor-pointer" // Added cursor-pointer to indicate it's clickable
  onClick={(e) => {
    e.stopPropagation(); // Prevent any parent click handlers from firing
    setSelectedVendor(item.vendor);
    setShowWindowVendorPopup(true);
  }}
/>

          <h5
            className="text-black text-base font-semibold truncate max-w-[220px]"
            title={item.item_name}
          >
            {item.item_name}
          </h5>
        </div>

        {/* Room names section */}
        <div className="grid grid-cols-2 gap-1 text-xs mb-3">
  {[...new Set(item.applied_areas.map(area => area.room_name))].map((roomName, index) => (
    <div key={index} className="flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-green-500 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
      <span className="text-gray-600">{roomName}</span>
    </div>
  ))}
</div>


        {/* Pricing details section */}
        <div className="rounded-md bg-gray-100 p-2 grid grid-cols-3 gap-1">
  {/* Quantity Column - Left aligned */}
  <div>
    <p className="text-xs font-medium text-gray-500">Quantity</p>
    <div className='flex items-center'>
      <p className='text-sm font-semibold'>{item.quantity}</p>
      <p className='text-gray-500 text-xs ml-1'>{item.UOM}</p>
    </div>
  </div>
  
  {/* Unit Price Column - Center aligned */}
  <div className="text-center">
    <p className="text-xs font-medium text-gray-500">Unit Price</p>
    <div className='flex items-center justify-center'>
      <p className='text-sm font-semibold'>₹{item.selling_price}</p>
      <p className='text-gray-500 text-xs ml-1'>/{item.UOM}</p>
    </div>
  </div>
  
  {/* Price Column - Right aligned */}
  <div className="text-right">
    <p className="text-xs font-medium text-gray-500 mr-4">Price</p>
  <p className='text-sm font-semibold text-[#14A311]'>
    ₹{Number(item.total).toLocaleString('en-IN')}
  </p>
  </div>
</div>

      </div>
    </div>
  ))}
</div>



{showWindowVendorPopup && selectedVendor && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-end justify-center">
    <div className="fixed inset-x-0 bottom-0 bg-white rounded-t-xl shadow-lg z-50 max-h-[80vh] overflow-y-auto transform transition-transform duration-300 ease-out">
      {/* Header with close button */}
      <div className="sticky top-0 bg-white px-4 py-3 border-b border-gray-200 z-10">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <h2 className="text-xl font-bold text-gray-800">Window Details</h2>
            <h3 className="text-sm text-gray-600">
              {selectedVendor?.product_sub_category_name || "Premium Windows"}
            </h3>
          </div>
          <button
            onClick={() => setShowWindowVendorPopup(false)}
            className="text-gray-500 hover:text-gray-700 p-1.5"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Popup content */}
      <div className="p-4">
        {/* Vendor information */}
        <div className="mb-4">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-sm font-medium text-gray-500">Vendor</h4>
            <span className="text-xs text-[#3C5DB1]">Certified Window Partner</span>
          </div>
          <div className="flex items-center bg-gray-50 p-3 rounded-lg border border-gray-200">
            {selectedVendor?.image && (
              <div className="mr-3 border border-gray-200 rounded-md p-1 bg-white">
                <img
                  src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + selectedVendor.image}
                  alt={selectedVendor.name || "Vendor"}
                  className="w-16 h-12 object-contain"
                />
              </div>
            )}
            <div>
              <h5 className="font-medium text-gray-800">{selectedVendor?.name || "Unknown Vendor"}</h5>
              {selectedVendor?.description ? (
                <p className="text-sm text-gray-600 mt-1 line-clamp-2">{selectedVendor.description}</p>
              ) : (
                <p className="text-sm text-gray-600 mt-1">Premium Window Manufacturer with Quality Assurance</p>
              )}
            </div>
          </div>
        </div>
        
        {/* Window details */}
        <div className="mb-4">
          <h4 className="text-sm font-medium text-gray-500 mb-2">Window Specifications</h4>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <p className="text-xs text-gray-500">Window Type</p>
                <p className="text-sm font-medium">
                  {selectedVendor?.window_type || selectedVendor?.item_name || "Sliding Window"}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Frame Material</p>
                <p className="text-sm font-medium">
                  {selectedVendor?.frame_material || "UPVC"}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Glass Type</p>
                <p className="text-sm font-medium">
                  {selectedVendor?.glass_type || "Double Glazed"}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Thickness</p>
                <p className="text-sm font-medium">
                  {selectedVendor?.thickness || "5mm"}
                </p>
              </div>
            </div>
            
            {selectedVendor?.description && (
              <div className="mt-3">
                <p className="text-xs text-gray-500">Description</p>
                <p className="text-sm mt-1">{selectedVendor.description}</p>
              </div>
            )}
            
            {/* Specifications if available */}
            {selectedVendor?.specifications && Object.keys(selectedVendor.specifications).length > 0 && (
              <div className="mt-3">
                <p className="text-xs text-gray-500 mb-1">Additional Specifications</p>
                <div className="space-y-1">
                  {Object.entries(selectedVendor.specifications).map(([key, value], index) => (
                    <div key={index} className="flex justify-between text-sm">
                      <span className="text-gray-600">{key}:</span>
                      <span className="font-medium">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* Features & Benefits section */}
        <div className="mb-4">
          <h4 className="text-sm font-medium text-gray-500 mb-2">Features & Benefits</h4>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <p className="text-xs text-gray-500">Sound Insulation</p>
                <p className="text-sm font-medium">
                  {selectedVendor?.sound_insulation || "High"}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Weather Resistance</p>
                <p className="text-sm font-medium">
                  {selectedVendor?.weather_resistance || "Excellent"}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Warranty</p>
                <p className="text-sm font-medium">{selectedVendor?.warranty || "5 Years"}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Installation</p>
                <p className="text-sm font-medium">{selectedVendor?.installation || "Included"}</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Customization information box */}
        <div className="bg-[#FFF8E6] border border-[#FFE7A3] rounded-lg p-3 mb-4">
          <div className="flex items-start">
            <div className="text-[#F5A623] mr-2 mt-0.5">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h5 className="text-sm font-medium text-[#8B6E00] mb-1">Want to customize your windows?</h5>
              <p className="text-xs text-[#8B6E00]">
                To change window or customize your selection, please close this popup and click the
                <span className="font-bold mx-1">Customize</span>
                button at the bottom of the screen.
              </p>
            </div>
          </div>
        </div>
        
        {/* Quality assurance section */}
        <div className="mb-4">
          <h4 className="text-sm font-medium text-gray-500 mb-2">Quality Assurance</h4>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
            <div className="flex items-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#14A311] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <p className="text-sm">Energy efficient design</p>
            </div>
            <div className="flex items-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#14A311] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <p className="text-sm">Weatherproof and durable</p>
            </div>
            <div className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#14A311] mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <p className="text-sm">Professional installation included</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex justify-center mb-2">
        <button
          onClick={() => setShowWindowVendorPopup(false)}
          className="border border-[#F30F0F] bg-white text-[#F30F0F] font-medium py-2.5 px-6 rounded-lg text-sm flex items-center justify-between"
        >
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
)}


<WindowListPopup 
  isOpen={showWindowListPopup}
  onClose={() => setShowWindowListPopup(false)}
  selectedWindowItem={selectedWindowItem}
/>
<Footer 
        totalPrice={Number(data.total)} 
        quotationId={quotationId}
        onCustomizeClick={handleCustomizeClick}
      />    
       
</div>
  );
}
  

export default WindowsStandardQuoteDetails;